const phoneValidator = (r: any, v: string | undefined) => {
    console.log('validator')
    if ( !v || ~v.indexOf('_'))
        return Promise.reject('Введите полностью')
    return Promise.resolve()
}

export default phoneValidator